<template>
  <v-dialog v-model="showModal" @keydown.esc="cancela" @click:outside="cancela" :max-width="'800px'">
    <v-form ref="form" lazy-validation>
      <v-card>
        <v-card-title>
          <span class="headline">{{ tituloModal }}</span>
        </v-card-title>
        <v-card-text>
          <v-container class="grey lighten-5">
            <v-row>
              <v-col cols="12" :sm="'12'" class="px-0">
                <v-textarea
                  id="justificativa_obrigatoria"
                  name="justificativa-obrigatoria"
                  v-model="justificativa"
                  auto-grow
                  autofocus
                  maxlength="150"
                  rows="1"
                  :rules="[rules.required]"
                  :disabled="somenteLeitura"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="somenteLeitura" @click.native="cancela">{{ $t('label.fechar') }}</v-btn>
          <v-btn v-if="!somenteLeitura && !modoEdicao" @click.native="cancela">{{ $t('label.cancelar') }}</v-btn>
          <v-btn v-if="!somenteLeitura && !modoEdicao" color="primary" @click.native="salvar">{{ $t('label.salvar') }}</v-btn>
          <v-btn v-if="modoEdicao" @click.native="cancela">{{ $t('label.nao') }}</v-btn>
          <v-btn v-if="modoEdicao" color="primary" @click.native="salvarEdicao">{{ $t('label.sim') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import {
  buscaAutocomplete,
  triggerSelecao,
} from '@/common/functions/autocomplete-utils';

export default {
  data() {
    return {
      workflowAcaoMagaluResource: this.$api.workflowAcaoMagalu(this.$resource),
      workflowContratoResource: this.$api.workflowContrato(this.$resource),
      planejamentoContratoResource: this.$api.planejamentoContratoCadastro(this.$resource),

      showModal: false,
      justificativa: '',
      rules: {
        required: (value) => (!!value && value.trim().length > 0) || this.$t('message.campo_obrigatorio'),
      },
      observacaoKey: 0,
    };
  },
  props: {
    obrigatorio: Boolean,
    salvarJustificativa: Function,
    somenteLeitura: {
      type: Boolean,
      default: false,
    },
    modoEdicao: {
      type: Boolean,
      default: false,
    },
    idAcao: Number,
    tituloModal: String,
  },
  watch: {
    idAcao() {
      this.formataCampos();
    },
  },
  computed: {
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
  },
  methods: {
    buscaAutocomplete,
    triggerSelecao,
    open(justificativaExistente = '') {
      this.justificativa = justificativaExistente;
      this.showModal = true;
    },
    cancela() {
      this.showModal = false;
      if (!this.modoEdicao) {
        this.$emit('cancelado');
      }
    },
    salvar() {
      if (!this.$refs.form.validate()) return;
      this.$emit('postJustificativa', this.justificativa);
      this.showModal = false;
    },
    salvarEdicao() {
      if (!this.$refs.form.validate()) return;
      this.$emit('atualizarJustificativa', this.justificativa);
      this.showModal = false;
    },
  },
};
</script>
